import { render, staticRenderFns } from "./OrderNote.vue?vue&type=template&id=a0c40de2&scoped=true&"
import script from "./OrderNote.vue?vue&type=script&lang=js&"
export * from "./OrderNote.vue?vue&type=script&lang=js&"
import style0 from "./OrderNote.vue?vue&type=style&index=0&id=a0c40de2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c40de2",
  null
  
)

export default component.exports